import {
    COLLECTION_TAB_FAILURE,
    OPEN_COLLECTION_TAB,
    SWITCH_COLLECTION_TABS
} from './types/collection-action-types';

import { findIndex } from 'lodash';
import { selectedCollectionWithCanvasesSelector } from '../selectors/collection-selectors';

export function openCollectionTab( props, tabMeta ){
    return ( dispatch, getState ) => {
        const state = getState();
        const canvasId = tabMeta.id;

        const collectionMeta = selectedCollectionWithCanvasesSelector( state, props );

        // check if selected canvas is owned by the selected collection
        const canvasIndex = findIndex( collectionMeta.canvases, ( canvas ) => canvas.id === canvasId );

        if( canvasIndex < 0 ){
            // if not, don't open the tab
            dispatch( {
                selectedCanvasId: canvasId,
                type: COLLECTION_TAB_FAILURE,
            } );
        }
        else{
            dispatch( {
                parentTab: collectionMeta,
                selectedTab: tabMeta,
                type: OPEN_COLLECTION_TAB,
            } );

            dispatch( switchCollectionTabs( tabMeta.id ) );
        }
    };
}

export function switchCollectionTabs( tabId ){
    return {
        selectedTabId: tabId,
        type: SWITCH_COLLECTION_TABS,
    };
}
